<template>
    <button
        class="btn btn-lg is-primary"
        :class="{ 'is-loading': loading }"
        @click="detach"
    >
        Frikoppla adress
    </button>
</template>
<script>
    export default {
        props: {
            deliveryProjectId: {
                type: Number,
                required: true,
            },
            addressId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                loading: false,
            };
        },

        methods: {
            async detach() {
                this.loading = true;

                try {
                    await axios.delete(route('api.delivery-projects.addresses.destroy', [this.deliveryProjectId, this.addressId]));
                } catch (error) {
                    this.loading = false;

                    return flash_error('Kunde tyvärr inte spara.');
                }

                this.loading = false;
                EventBus.$emit('remove-address-marker', this.addressId);
                flash_success('Adressen är borttagen!');
            },
        },
    };
</script>
